import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV, faTable } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { Chart as ChartJS } from "chart.js/auto";
import { Doughnut } from "react-chartjs-2";
import { apiTopDevelopersInOfficeDevelopment } from "../../services/apis/retail/apiTopDevelopersInOfficeDevelopment";

class TopDevelopersInOfficeDevelopment extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      chartOtions: {},
      chartData: {
        labels: [],
        datasets: [],
      },
    };
  }

  componentDidMount() {
    const options = {
      responsive: true,
      type: "doughnut",
      radius: "80%",
      animation: { animateRotate: false, animateScale: true },
      // maintainAspectRatio: true,
      plugins: {
        legend: {
          display: false,
          // position: 'top',
        },
        title: {
          display: false,
          // text: 'Chart.js Bar Chart',
        },
        datalabels: {
          color: "white",
          display: function (ctx) {
            return ctx.dataset.data[ctx.dataIndex] > 35000000;
          },
          formatter: function (value) {
            return Math.round(value / 1000000, 2) + "mn";
          },
          font: {
            weight: "bold",
          },
          offset: 0,
          padding: 0,
        },
      },
      scales: {
        x: {
          ticks: {
            display: false, //this will remove only the label
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
        y: {
          ticks: {
            display: false, //this will remove only the label
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
      },
      aspectRatio: 0.5,
    };

    apiTopDevelopersInOfficeDevelopment.get().then((res) => {
      const data = {
        labels: res.data.x,
        datasets: [
          {
            // label: "My First Dataset",
            data: res.data.y,
            backgroundColor: res.data.bgcolor,
            hoverOffset: 4,
            // datalabels: {
            //   display: true,
            //   color: "white"
            // }
            /*datalabels: {
                            labels: {
                                index: {
                                    align: 'end',
                                    anchor: 'end',
                                    color: function (ctx) {
                                        return ctx.dataset.backgroundColor;
                                    },
                                    font: { size: 18 },
                                    formatter: function (value, ctx) {
                                        return ctx.active
                                            ? ctx.chart.data.labels[ctx.dataIndex]
                                            : '';
                                    },
                                    offset: 8,
                                    opacity: function (ctx) {
                                        return ctx.active ? 1 : 0.5;
                                    }
                                },
                                // name: {
                                //   align: 'top',
                                //   font: {size: 16},
                                //   formatter: function(value, ctx) {
                                //     return ctx.active
                                //       ? 'name'
                                //       : ctx.chart.data.labels[ctx.dataIndex];
                                //   }
                                // },
                                value: {
                                    // align: 'top',
                                    backgroundColor: function (ctx) {
                                        var value = ctx.dataset.data[ctx.dataIndex];
                                        return value > 50 ? 'white' : null;
                                    },
                                    borderColor: 'white',
                                    borderWidth: 2,
                                    borderRadius: 4,
                                    color: function (ctx) {
                                        var value = ctx.dataset.data[ctx.dataIndex];
                                        return value > 50
                                            ? ctx.dataset.backgroundColor
                                            : 'white';
                                    },
                                    formatter: function (value, ctx) {
                                        return ctx.active
                                            ? Math.round(value * 1000) / 1000
                                            : Math.round(value * 1000) / 1000;
                                    },
                                    padding: 4
                                }
                            }
                        }*/
          },
        ],
      };

      this.setState({
        chartOtions: options,
        chartData: data,
      });
    });
  }
  render() {
    // const plugins = [{
    //   beforeDraw: function(chart) {
    //    var width = chart.width,
    //        height = chart.height,
    //        ctx = chart.ctx;
    //        ctx.restore();
    //        var fontSize = (height / 160).toFixed(2);
    //        ctx.font = fontSize + "em sans-serif";
    //        ctx.textBaseline = "top";
    //        var text = "Foo-bar",
    //        textX = Math.round((width - ctx.measureText(text).width) / 2),
    //        textY = height / 2;
    //        ctx.fillText(text, textX, textY);
    //        ctx.save();
    //   }
    // }];

    return (
      <div className="col-lg-6" id="#section2">
        <div className="widget widgetTable">
          <div className="row">
            <div className="col-lg-9 text-start colorLightBlue widgetTableHeader mb-3">
              <p>Top Developers in Ofﬁce Development</p>
            </div>
            <div className="col-lg-3 text-end">
              <Link to="/#" className="pe-3">
                <FontAwesomeIcon icon={faTable} />
              </Link>
              <Link to="/#" className="colorBlack">
                <FontAwesomeIcon icon={faEllipsisV} />
              </Link>
            </div>
            <div className="col-lg-12">
              <Doughnut
                options={this.state.chartOtions}
                data={this.state.chartData}
                // plugins={plugins}
                // plugins={[ChartDataLabels]}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TopDevelopersInOfficeDevelopment;
